import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";

interface Props {
  ref: React.RefObject<HTMLElement>;
  resetTrigger?: string | boolean;
}

export const useTouched = ({ ref, resetTrigger }: Props): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
  const [touched, setTouched] = useState(false);

  const handleFocus = useMemo(
    () =>
      debounce(() => {
        setTouched(true);
      }, 500),
    [],
  );

  useEffect(() => {
    setTouched(false);
  }, [resetTrigger]);

  useEffect(() => {
    const currentRef = ref.current;
    currentRef?.addEventListener("focusin", handleFocus, false);

    return () => {
      currentRef?.removeEventListener("focusin", handleFocus, false);
    };
  }, [ref, handleFocus]);

  return [touched, setTouched];
};
